import React from 'react';
import { IndicatorContext } from '../context';

export function useIndicators() {
  return React.useContext(IndicatorContext);
}
